import { render, staticRenderFns } from "./KurccFormPreview.vue?vue&type=template&id=8994a6b8&scoped=true&"
import script from "./KurccFormPreview.vue?vue&type=script&lang=js&"
export * from "./KurccFormPreview.vue?vue&type=script&lang=js&"
import style0 from "./KurccFormPreview.vue?vue&type=style&index=0&id=8994a6b8&lang=scss&scoped=true&"
import style1 from "./KurccFormPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8994a6b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VFooter,VForm,VIcon,VProgressCircular,VRow})
